import React from 'react'
import { Link } from "react-router-dom"

import {
    FooterLogo,
    FooterWrapper1,
    FooterWrapper2,
    FooterComP,
    TermCond,
    SupportLink,
    LastSupportLink,
    SocialMedia,
    LastSocialMedia
} from "./FooterElements"

import logo from "../../assets/images/logo.svg"
import twitter from "../../assets/images/twitter.svg"
import instagram from "../../assets/images/instagram.svg"
import linkedin from "../../assets/images/linkedin.svg"


const Footer = () => {
    return (
        <div className="footer">
            <FooterWrapper1>
                <FooterLogo to="/" onClick={() => { window.scroll(0, 0) }}>
                    <img src={logo} alt="MyPipe logo" />
                    <h1 className="logo-text">MyPipe</h1>
                </FooterLogo>
                <FooterWrapper2>
                    <div className="footer-wrap2">
                        <FooterComP>
                            © MyPipe App 2022 All rights reserved.
                        </FooterComP>
                        <TermCond>
                            <Link to="/terms_services" onClick={() => { window.scroll(0, 0) }}>Terms of service</Link> | <Link to="/privacy_policy" onClick={() => { window.scroll(0, 0) }}>Privacy Policy</Link>
                        </TermCond>
                    </div>
                    <div className="footer-contact">
                        <div>
                            <SupportLink>
                                <Link to="/">Contact Us</Link>
                            </SupportLink>
                            <SupportLink>
                                <Link to="/">FAQs</Link>
                            </SupportLink>
                            <LastSupportLink>
                                <Link to="/">Support</Link>
                            </LastSupportLink>
                        </div>
                        <div className="footer-sm">
                            <SocialMedia>
                                <Link to="/"><img src={twitter} className="sm-icon" alt="twitter icon" /></Link>
                            </SocialMedia>
                            <SocialMedia>
                                <Link to="/"><img src={instagram} className="sm-icon" alt="instagram icon" /></Link>
                            </SocialMedia>
                            <LastSocialMedia>
                                <Link to="/"><img src={linkedin} className="sm-icon" alt="linkedin icon" /></Link>
                            </LastSocialMedia>
                        </div>
                    </div>
                </FooterWrapper2>
            </FooterWrapper1>
        </div>
    )
}

export default Footer
